import { document } from "@packages/global";
import { useEffect, useRef, useState } from "react";
import { ArrowDownIcon } from "../../icons";
import styles from "./select-slider.module.css";

type Item = {
  value: string;
  label: string;
};

type Props = {
  items: Item[];
  value: Item;
  onChange: (item: Item) => void;
};

export function SelectSlider({ items, value, onChange }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [dataQaDevice, setDataQaDevice] = useState('');

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const handleItemClick = (item: Item) => {
    onChange(item);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    if (window.innerWidth < 842) {
      setDataQaDevice('-mobile');
    } else {
      setDataQaDevice('');
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className={styles.DropdownContainer} ref={dropdownRef}>
      <button
        type="button"
        className={styles.DropdownButton}
        onClick={toggleDropdown}
        data-qa={`select_km${dataQaDevice}`}
      >
        {value.label}
        <span>
          <ArrowDownIcon color="#6A6977" size={24} />
        </span>
      </button>
      {isOpen && (
        <ul className={styles.DropdownMenu}>
          {items.map((item) => (
            <li
              key={item.value}
              className={styles.DropdownItem}
              onClick={() => handleItemClick(item)}
              onKeyDown={() => handleItemClick(item)}
              data-qa={`select_km_${item.value}${dataQaDevice}`}
            >
              {item.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
